<script setup lang="ts">
useHead({
  htmlAttrs: {
    lang: "ur-Latn", // custom, but important
  },
  meta: [
    { name: "google", content: "notranslate" },
    // Global OpenGraph Tags
    { property: "og:site_name", content: "Rozay - Ramadan 2026 Pakistan" },
    { property: "og:type", content: "website" },
    { property: "og:locale", content: "ur_PK" },
    // Global Twitter Tags
    { name: "twitter:site", content: "@rozaytoday" },
    { name: "twitter:creator", content: "@rozaytoday" },
    // Additional SEO
    { name: "theme-color", content: "#059669" },
    { name: "apple-mobile-web-app-capable", content: "yes" },
    {
      name: "apple-mobile-web-app-status-bar-style",
      content: "black-translucent",
    },
  ],
});
</script>
<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <!-- Put notifications once, globally -->
    <UNotifications />
  </UApp>
</template>
